import * as Types from '../../../../__generated__/graphql-base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetJsProPremiumAccessQueryVariables = Types.Exact<{ [key: string]: never }>;

export type GetJsProPremiumAccessQuery = {
    __typename?: 'Query';
    jobSeekerProfile?:
        | {
              __typename?: 'JobSeekerProfilePayload';
              profile?:
                  | {
                        __typename?: 'JobSeekerProfile';
                        jsProPremiumAccess?:
                            | {
                                  __typename?: 'JsProPremiumAccess';
                                  autoApplyAccess?:
                                      | {
                                            __typename?: 'JsProPremiumAccessResult';
                                            tier?:
                                                | Types.JsSubscriptionAccessTier
                                                | null
                                                | undefined;
                                        }
                                      | null
                                      | undefined;
                              }
                            | null
                            | undefined;
                    }
                  | null
                  | undefined;
          }
        | null
        | undefined;
};

export const GetJsProPremiumAccessDocument = gql`
    query GetJsProPremiumAccess {
        jobSeekerProfile {
            profile {
                jsProPremiumAccess {
                    autoApplyAccess {
                        tier
                    }
                }
            }
        }
    }
`;

/**
 * __useGetJsProPremiumAccessQuery__
 *
 * To run a query within a React component, call `useGetJsProPremiumAccessQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJsProPremiumAccessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJsProPremiumAccessQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetJsProPremiumAccessQuery(
    baseOptions?: Apollo.QueryHookOptions<
        GetJsProPremiumAccessQuery,
        GetJsProPremiumAccessQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<GetJsProPremiumAccessQuery, GetJsProPremiumAccessQueryVariables>(
        GetJsProPremiumAccessDocument,
        options,
    );
}
export function useGetJsProPremiumAccessLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetJsProPremiumAccessQuery,
        GetJsProPremiumAccessQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<GetJsProPremiumAccessQuery, GetJsProPremiumAccessQueryVariables>(
        GetJsProPremiumAccessDocument,
        options,
    );
}
export function useGetJsProPremiumAccessSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetJsProPremiumAccessQuery,
              GetJsProPremiumAccessQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<GetJsProPremiumAccessQuery, GetJsProPremiumAccessQueryVariables>(
        GetJsProPremiumAccessDocument,
        options,
    );
}
export type GetJsProPremiumAccessQueryHookResult = ReturnType<typeof useGetJsProPremiumAccessQuery>;
export type GetJsProPremiumAccessLazyQueryHookResult = ReturnType<
    typeof useGetJsProPremiumAccessLazyQuery
>;
export type GetJsProPremiumAccessSuspenseQueryHookResult = ReturnType<
    typeof useGetJsProPremiumAccessSuspenseQuery
>;
export type GetJsProPremiumAccessQueryResult = Apollo.QueryResult<
    GetJsProPremiumAccessQuery,
    GetJsProPremiumAccessQueryVariables
>;
